<template>
  <div class="mb-1">
    <div class="p-1" role="tab">
      <div v-b-toggle="'faq-' + index">
        {{ question }}
        <div class="float-right">
          <span class="when-opened">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 15L12 9L6 15"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="when-closed">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
      <b-collapse
        :id="'faq-' + index"
        role="tabpanel"
        class="faq-answer"
        v-html="answer"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    index: Number,
    question: String,
    answer: String
  }
};
</script>

<style>
ol.faq {
  font-size: 26px;
  line-height: 32px;

  color: rgba(0, 0, 0, 0.7);
}

ol.faq li {
  border-bottom: 1px solid rgba(155, 160, 177, 0.5);
  padding: 20px 0 10px 0;
}

.faq-answer {
  font-size: 20px;
  line-height: 28px;
  padding: 10px 0 0 0;

  color: rgba(0, 0, 0, 0.7);
}

.collapsed > div > .when-opened,
:not(.collapsed) > div > .when-closed {
  display: none;
}
</style>
